import type { AxiosInstance } from 'axios';
import { SilentError } from 'init/silent-error';
import { handleZodError } from 'shared/hooks/utils';
import { z } from 'zod/v4';

// The api-backed filter option endpoints return a JSON:API list. The per-item
// shape varies by filter, so we only validate the envelope and hand back the raw
// resources for the caller to serialise.
const FilterOptionsSchema = z
  .object({ data: z.array(z.unknown()) })
  .transform(response => response.data);

export async function loadFilterOptionsQueryFn(
  axiosInstance: Promise<AxiosInstance>,
  path: string,
) {
  const instance = await axiosInstance;
  const { data } = await instance.get(path);

  const parseResult = FilterOptionsSchema.safeParse(data);
  if (!parseResult.success) {
    handleZodError(parseResult, 'filter options');
    throw new SilentError();
  }

  return parseResult.data;
}
